function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6673 5L11.0311 5.343C11.2127 5.15039 11.2127 4.84961 11.0311 4.657L10.6673 5ZM7.25989 0.657003C7.07045 0.45608 6.75401 0.446764 6.55308 0.636197C6.35216 0.825629 6.34285 1.14207 6.53228 1.343L7.25989 0.657003ZM6.53228 8.657C6.34285 8.85793 6.35216 9.17437 6.55308 9.3638C6.75401 9.55324 7.07045 9.54392 7.25989 9.343L6.53228 8.657ZM1.33398 4.5C1.05784 4.5 0.833984 4.72386 0.833984 5C0.833984 5.27614 1.05784 5.5 1.33398 5.5V4.5ZM11.0311 4.657L7.25989 0.657003L6.53228 1.343L10.3035 5.343L11.0311 4.657ZM7.25989 9.343L11.0311 5.343L10.3035 4.657L6.53228 8.657L7.25989 9.343ZM10.6673 4.5H1.33398V5.5H10.6673V4.5Z",
  fill: "url(#paint0_linear_3884_62299)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3884_62299",
  x1: 10.6673,
  y1: 5,
  x2: 1.33398,
  y2: 5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B2FF"
})));

function SvgArrowRightGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGradient);
export default __webpack_public_path__ + "static/media/ArrowRightGradient.6b968b0e704cb57ad7fcb46a93a04408.svg";
export { ForwardRef as ReactComponent };